import * as React from 'react';
/**
 * Установить данную ссылку на данное значение
 * Этот утилита обрабатывает разные типы ссылок: callback refs и RefObject(s)
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null && ref !== undefined) {
    ref.current = value;
  }
}

/**
 * Утилита для объединения нескольких ссылок вместе
 * Принимает callback refs и RefObject(s)
 */
function composeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    return refs.forEach(function (ref) {
      return setRef(ref, node);
    });
  };
}

/**
 * Пользовательский хук, который объединяет несколько ссылок
 * Принимает callback refs и RefObject(s)
 */
function useComposedRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(composeRefs.apply(void 0, refs), refs);
}
export { composeRefs, useComposedRefs };